export default {
  BenefitsGroup: [],
  selectedBenefitGroup: null,
  error: false,
  errorMessage: ''
}